<template>
  <div>
    <base-table-card
      ref="base-card"
      :title="title"
      :fields="captions" 
      :hideFields="hideFields"
      :isBusy="isBusy"
      :isSortable="false"
      :getDataFunction="getDataFunction"
      :showAddButton="showAddButton"

      @onAdd="$emit('onAdd', $event)"
      @onSortHeadClicked="$emit('onSortHeadClicked', $event)" 
      @rowClicked="$emit('rowClicked', $event)"
      @onRefreshClick="$emit('onRefreshClick')"
    >
      <template v-slot:header-actions>
        <slot name="header-actions"></slot>
      </template>

      <template v-slot:filter>
        <slot name="filter"></slot>
      </template>

      <template #cell(serialNumber)="row">
        <div class="text-muted"><b>{{ String(row.item.serialNumber).padStart(6,'0') }}</b></div>
        <div>{{ getDateFormat(row.item.creationDate, 'yyyy-mm-dd') }}</div>
      </template>

      <template #cell(energyName)="row">
        <b-badge :variant="row.item.energyPublicCode==='coldwater' ? 'primary' : 'danger'">{{ row.item.energyName }}</b-badge>
      </template>

      <template #cell(status)="row">
        <b-badge v-if="row.item.status==='created'" variant="warning">создан</b-badge>
        <b-badge v-if="row.item.status==='signed'" variant="success">подписан</b-badge>
      </template>

      <template #cell(period)="row">
        <div class="d-flex flex-column mr-0">
          <div class="d-flex">
            <i class="ml-2">{{ getDateFormat(row.item.periodFrom, 'yyyy-mm-dd') }} -</i> 
          </div>
          <div class="d-flex">
            <i class="ml-2">{{ getDateFormat(row.item.periodTo, 'yyyy-mm-dd') }}</i>
          </div>
        </div>
      </template>

      <template #cell(countActsCold)="row">
        <b-badge v-if="row.item.countActsCold" variant="primary">{{ row.item.countActsCold }}</b-badge>
      </template>

      <template #cell(countPlombsCold)="row">
        <b-badge v-if="row.item.countPlombsCold" variant="primary">{{ row.item.countPlombsCold }}</b-badge>
      </template>

      <template #cell(countActsHotIn)="row">
        <b-badge v-if="row.item.countActsHotIn" variant="danger">{{ row.item.countActsHotIn }}</b-badge>
      </template>

      <template #cell(countActsHotOut)="row">
        <b-badge v-if="row.item.countActsHotOut" variant="danger">{{ row.item.countActsHotOut }}</b-badge>
      </template>

      <template #cell(countPlombsHot)="row">
        <b-badge v-if="row.item.countPlombsHot" variant="danger">{{ row.item.countPlombsHot }}</b-badge>
      </template>

      <template #cell(actNumber)="row">
        <b-button v-if="row.item.actNumber && row.item.idUserTask" @click="$router.push({ path: `/act/${row.item.idUserTask}`})" size="sm" variant="info" class="ml-1">{{ row.item.actNumber }}</b-button>
      </template>

      <template v-slot:actions="props">
        <slot name="actions" :item="props.item"></slot>
      </template>

      <template #row-details="row">
        
      </template>
    </base-table-card>
  </div>
</template>

<script>
  import DateFormat  from 'dateformat'
  import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'

export default {
  name: 'table-reestr',
  inheritAttrs: false,
  props: {   
    title: {
      type: String,
      default: null
    },

    showAddButton: {
      type: Boolean,
      default: false
    },

    getDataFunction: {
      type: Function,
      default: null
    },

    isBusy: {
      type: Boolean,
      default: false      
    },

    showCompanyName: {
      type: Boolean,
      default: true
    }
  },

  data: () => {
    return {
      hideFields: [],
      captions: [
        //{ key: "details", label: '', sortable: false, thStyle: { width: '4%'} },
        { key: "serialNumber", label: 'Серийный номер', sortable: false },
        //{ key: "creationDate", label: 'Дата', sortable: false },
        { key: "energyName", label: 'Энергоноситель', sortable: false },
        { key: "status", label: 'Статус', sortable: false },
        { key: "period", label: 'Период', sortable: false },
        //{ key: "countActs", label: 'Кол-во электронных актов', sortable: false },
        { key: "countActsCold", label: 'Актов х.в.', sortable: false },
        { key: "countPlombsCold", label: 'Пломб х.в.', sortable: false },
        { key: "countActsHotOut", label: 'Актов из. г.в.', sortable: false },
        { key: "countActsHotIn", label: 'Актов доп. г.в.', sortable: false },        
        { key: "countPlombsHot", label: 'Пломб г.в.', sortable: false },
        { key: "companyName", label: 'Компания', sortable: false },
        { key: "actions", label: '', sortable: false, thStyle: { width: '4%'} },
      ],
    }
  },

  computed: {
    ...mapGetters(['isSuperAdmin', 'isAdminEnergyCompany', 'companyEnergies']),
  },

  watch: {
    showCompany() {
      this.recalculateCaptions()
    }
  },

  methods: {   
    recalculateCaptions() {
      this.hideFields = []

      if (!this.showCompanyName) {
        this.hideFields.push('companyName')
      }

      if (this.isAdminEnergyCompany) {
        if (this.companyEnergies.indexOf('hotwater') < 0) {
          this.hideFields.push('countActsHotOut')
          this.hideFields.push('countActsHotIn')
          this.hideFields.push('countPlombsHot')
        }

        if (this.companyEnergies.indexOf('coldwater') < 0) {
          this.hideFields.push('countActsCold')
          this.hideFields.push('countPlombsCold')
        }
      }
    }, 

    getDateFormat(date, format) {
      return DateFormat(date, format)
    },

    getData() {
      this.$refs['base-card'].getData()
    }
    
  },

  mounted() {
    this.recalculateCaptions()
  }
}
</script>
